import React from "react";
import css from "./Title.module.css";


export default function Title(props){
    const {text=props.title||props.children}=props;
    return (
        <h3 
            className={`${css.title} ${props.className||""}`} 
            style={props.style}
        >{text}</h3>
    )
}
